import * as React from "react"
import Card from "@mui/material/Card"
import CardActions from "@mui/material/CardActions"
import CardContent from "@mui/material/CardContent"
import CardMedia from "@mui/material/CardMedia"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"

class MediaCard extends React.Component {
	componentDidMount() {}

	render() {
		return (
			<Card sx={{ maxHeight: 400 }}>
				<CardMedia
					component="img"
					height="300"
					image={this.props.image}
					alt={this.props.name}
				/>
				<CardContent>
					<Typography gutterBottom variant="h5" component="div">
						{this.props.name}
					</Typography>
					<Typography variant="body2" color="text.secondary">
						{this.props.description}
					</Typography>
				</CardContent>
				<CardActions>
					<Button size="small">Share</Button>
					<Button size="small">Learn More</Button>
				</CardActions>
			</Card>
		)
	}
}

export default MediaCard
